export default import.meta.ROLLDOWN_FILE_URL_wkINkr1ClyKO3k6Zht3DXg